const returnLinks = {
  chronopost: "/carriers/relay_points/chronopost",
  colis_prive: "/carriers/relay_points/colis_prive",
  mondial_relay: "/carriers/relay_points/mondial_relay",
  colissimo: {
    fr: "/carriers/relay_points/colissimo",
    be: "https://www.bpost.be/fr/points-de-vente",
    de: "https://www.deutschepost.de/de/s/standorte.html",
    nl: "https://www.postnl.nl/locatie-wijzer",
    lu: "https://www.post.lu/particuliers/colis-courrier/trouver-un-point-de-vente",
    es: "https://www.correos.es/es/es/herramientas/oficinas-buzones-citypaq/detalle",
    ie: "https://anpost.com/Store-Locator",
    pt: "https://ctt.pt/feapl_2/app/open/stationSearch/stationSearch.jspx",
    se: "https://postnord.se/en/our-tools/search-letter-box-or-service-point/",
    it: "https://www.poste.it/prenotazione/vieni-in-poste?vieni-in-poste",
    at: "https://post.at/sf/standortfinder",
    dk: "https://postnord.dk/en/tools/find-us/",
    pl: "https://www.poczta-polska.pl/znajdz-punkt",
    cz: "https://postaonline.cz/vyhledat-pobocku",
    sk: "https://posta.sk/pobocky-a-balikoboxy",
    si: "https://en.posta.si/post-offices",
  },
};

// Get the return link for a given carrier and country,
// which could go to an internal page for mondial_relay, colis_prive, chronopost or colissimo in France;
// for Colissimo in another country, it will redirect to the appropriate external page.
const getReturnLink = (carrier, country) => {
  const links = returnLinks[carrier];
  if (typeof links === "string") {
    return links;
  }

  return links[country?.toLowerCase() || "fr"];
};

export { getReturnLink };
